"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PaymentProviderItem = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PaymentProviderItem = props => {
  const {
    provider,
    isActive,
    activatePaymentProvider
  } = props;
  const {
    name,
    blockReason,
    imageUrl,
    paymentProviderId
  } = provider;
  const isBlocked = blockReason !== null;
  const ownerState = {
    isActive
  };
  const handleClick = (0, _react.useCallback)(() => {
    activatePaymentProvider(isBlocked, paymentProviderId);
  }, [activatePaymentProvider, isBlocked, paymentProviderId]);
  const handleKeyPress = (0, _react.useCallback)(event => {
    switch (event.code) {
      case 'Space':
      case 'Enter':
        activatePaymentProvider(isBlocked, paymentProviderId);
        break;
      default:
        break;
    }
  }, [activatePaymentProvider, isBlocked, paymentProviderId]);
  if (isBlocked && !isActive) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PaymentProviderBox, {
    ownerState: ownerState,
    "aria-checked": isActive,
    role: "radio",
    tabIndex: 0,
    "aria-labelledby": `option-${paymentProviderId}`,
    "data-payment-provider-id": paymentProviderId,
    onClick: handleClick,
    onKeyDown: handleKeyPress,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.PaymentHeader, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        id: `option-${paymentProviderId}`,
        children: isActive ? /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
          children: name
        }) : name
      }), imageUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LazyImageTopIcon, {
        src: imageUrl,
        alt: name,
        loading: "eager"
      }) : null]
    })
  });
};
exports.PaymentProviderItem = PaymentProviderItem;
var _default = exports.default = PaymentProviderItem;
//# sourceMappingURL=PaymentProviderItem.js.map